import { Paper, Typography } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet-async";
import styled from "styled-components/macro";

import OTPSignIn from "../../components/auth/OTPSignIn";
import SignInComponent from "../../components/auth/SignIn";
import useAuth from "../../hooks/useAuth";
import { ReactComponent as Logo } from "../../vendor/logo-dark.svg";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

const Brand = styled(Logo)`
  width: 150px;
  height: 50px;
  margin-bottom: 20px;
`;

const LogoCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

function SignIn() {
  const { method } = useAuth();

  return (
    <React.Fragment>
      <Wrapper>
        <LogoCenter>
          <Brand />
        </LogoCenter>
        <Helmet title="Sign In" />
        <Typography component="h2" variant="body1" align="center">
          Sign in to your account to continue
        </Typography>

        {method === "cookie" ? <OTPSignIn /> : <SignInComponent />}
      </Wrapper>
    </React.Fragment>
  );
}

export default SignIn;
